import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Icons } from '@monorepo/icons';
import { AccountState, AccountStatus } from '@monorepo/types';
import { IconsNames } from '@monorepo/types';
import { Label, TextComponent, Tooltip } from '../../ui-kit';
import { getTagSettings } from './account-status-tag-util';

interface Props {
  status: AccountStatus;
  state?: AccountState;
  fill?: boolean;
}

export const AccountStatusTag: FunctionComponent<Props> = ({
  status = AccountStatus.Active,
  state,
  fill = false,
}) => {
  const { t } = useTranslation(['common']);
  const settings = getTagSettings(status, state);

  const statusTooltip = settings?.tooltip;

  return (
    <Tooltip title={statusTooltip}>
      <Label
        fill={fill}
        className="account-status-tag"
        onClick={(event) => event.stopPropagation()}
        color={settings?.color}
      >
        <span className="account-status-inner">
          {statusTooltip && <Icons iconName={IconsNames.QuestionCircle} />}
          <TextComponent capitalize level={9}>
            {t(`common:account_status.${status}`, {
              defaultValue: status.replace(/-/g, '_'),
            })}
          </TextComponent>
        </span>
      </Label>
    </Tooltip>
  );
};
